import React from "react"
import {Deal} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {Hr} from "@irati/ui/src/Layout"
import {ButtonLink} from "@irati/ui/src/Link"
import trimProtocolFromUrl from "@irati/deals/helpers/deals/trimProtocolFromUrl"
import idHelper from "@irati/utils/id"

interface Props {
  id?: string
  deal: Deal
}

const DealImportantInfoWebsiteUrl: React.FC<Props> = ({deal, ...props}) => {
  const {websiteUrl} = deal
  if (!websiteUrl) {
    return null
  }
  const trimmedWebsiteUrl = websiteUrl ? trimProtocolFromUrl(websiteUrl) : null

  return (
    <div id={idHelper("websiteUrl", props)}>
      <Hr />
      <Flex justifyContent="center">
        <ButtonLink cta href={websiteUrl} target="_blank">
          {trimmedWebsiteUrl}
        </ButtonLink>
      </Flex>
    </div>
  )
}

export default DealImportantInfoWebsiteUrl
